// extracted by mini-css-extract-plugin
export default {"section-title":"TitleSection_section-title__fTGpX","title":"TitleSection_title__6dT1S","custom-padding":"TitleSection_custom-padding__I3oDD"};